
<template>
   <div class="">
       <FormCreate/>
   </div>
</template>

<script>
import { tableAttributes } from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import FormCreate from './FormCreate'

export default {
  name: "tableItems",
  components:{FormCreate},
  data() {
    return {
      
    
    };
  },
};
</script>